"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Vc = (props) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 192 128", ...props },
    react_1.default.createElement("path", { fill: "#fcd022", d: "M0 0h192v128H0z" }),
    react_1.default.createElement("path", { fill: "#007c2e", d: "M144 0h48v128h-48z" }),
    react_1.default.createElement("path", { fill: "#002674", d: "M0 0h48v128H0z" }),
    react_1.default.createElement("path", { fill: "#007c2e", d: "M83.911 92.44 96 115.196l12.089-22.756L96 69.685zM68.267 64l12.089 22.755L92.444 64 80.356 41.244zm31.289 0 12.088 22.756L123.734 64l-12.09-22.756z" })));
exports.default = Vc;
//# sourceMappingURL=Vc.js.map